import PropTypes from 'prop-types';

export const RoleAssignmentTableShell = ({ children }) => (
  <div className="role-assignment-table-main-container">
    <div className="role-assignment-table-container">
      <div className="role-assignment-table-wrapper">{children}</div>
    </div>
  </div>
);

RoleAssignmentTableShell.propTypes = {
  children: PropTypes.node.isRequired,
};
